module.exports = __webpack_public_path__ + "img/logo8.9f6ab906.png";